/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import * as themeTypes from '../constants/ThemeTypes';

/* eslint max-len: ["error", { "code": 325, "tabWidth": 4 }] */
export default (state = {objectTheme: themeTypes.lightTheme, indexTheme: themeTypes.LIGHT_THEME}, action) => {
    switch (action.type) {
        case types.CHANGE_THEME:
            return {
                objectTheme: action.theme === themeTypes.LIGHT_THEME? themeTypes.lightTheme : themeTypes.darkTheme,
                indexTheme: action.theme,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/theme.js